import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import '../assets/css/style_outer.css';
import '../assets/js/payment.js';
import '../assets/js/custom.js';


//PrivateRoute
import home from './home';
import Header from './Header';
import Footer from './Footer';
import Contact from './Contact';
import Terms_of_service from './Terms_of_service';
import Privacy_policy from './Privacy_policy';
import Checkout from './Checkout';
import Headercanterlogo from './Headercanterlogo';
import Account_settings from './Account_settings';
import Slidemenu from './Slidemenu';
import Booking_History from './Booking_History';
import Addresses from './Addresses';
import Family_member from './Family_member';
import No_family_members from './No_family_members';
import No_booking_history from './No_booking_history';
import No_addresses from './No_addresses';
import Test_Detail from './Test_Detail';
import Lab_Detail from './Lab_Detail';
import Headermain from './Headermain';





import * as ROUTES from '../routes/routes';


class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentDidMount() {
    this.setState({
      isLoaded: true,
    });
  }

  componentWillUnmount() {
    this.state['isLoaded'] = false;
  }

  render() {
    return (
      <Router onUpdate={() => window.scrollTo(0, 0)}>
        <Route
          render={
            ({ location }) => (
              <Switch location={location}>
                <GuestRoute exact path={ROUTES.HOME} component={home} />
                <GuestRoute exact path={ROUTES.HEADER} component={Header} />
                <GuestRoute exact path={ROUTES.FOOTER} component={Footer} />
                <GuestRoute exact path={ROUTES.CONTACT} component={Contact} />
                <GuestRoute exact path={ROUTES.TERMS_OF_SERVICE} component={Terms_of_service} />
                <GuestRoute exact path={ROUTES.PRIVACY_POLICY} component={Privacy_policy} />
                <GuestRoute exact path={ROUTES.CHECKOUT} component={Checkout} />
                <GuestRoute exact path={ROUTES.HEADERCANTERLOGO} component={Headercanterlogo} />
                <GuestRoute exact path={ROUTES.ACCOUNT_SETTINGS} component={Account_settings} />
                <GuestRoute exact path={ROUTES.SLIDEMENU} component={Slidemenu} />
                <GuestRoute exact path={ROUTES.Booking_History} component={Booking_History} />
                <GuestRoute exact path={ROUTES.ADDRESSES} component={Addresses} />
                <GuestRoute exact path={ROUTES.FAMILY_MEMBER} component={Family_member} />
                <GuestRoute exact path={ROUTES.No_family_members} component={No_family_members} />
                <GuestRoute exact path={ROUTES.No_addresses} component={No_addresses} />
                <GuestRoute exact path={ROUTES.No_booking_history} component={No_booking_history} />
                <GuestRoute exact path={ROUTES.Test_Detail} component={Test_Detail} />
                <GuestRoute exact path={ROUTES.Lab_Detail} component={Lab_Detail} />
                <GuestRoute exact path={ROUTES.HEADERMAIN} component={Headermain} />
              </Switch>
            )
          } />
      </Router>
    )
  }
}

function PrivateRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => authenticated === true || localStorage.auth == 'true'
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      }
    />
  )
}

function GuestRoute({ component: Component, authenticated, ...rest }) {
  console.log(rest);
  return (
    <Route
      {...rest}
      render={(props) => authenticated === true
        ? <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        : <Component {...props} />
      }
    />
  )   
}

function PrivateGuestRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} />
      }
    />
  )
}
export default App;